<script>
import CustomerPreview from "./CustomerPreview.vue";
import mixin from "../../utilities/mixin";

export default {
  name: "DocsMain",
  components: {CustomerPreview},
  mixins: [mixin],
  data() {
    return {
      selectedCustomer: null,
      selectedTemplates: [],
      selectedTechs: [],
      takeRecord: false
    }
  },
  computed: {
    templates() {
      return this.$store.state.templates;
    },
    formQNums() {
      return this.$store.state.formQNums;
    },
    customers() {
      const customers = Object.values(this.$store.state.customers ?? {});
      return customers.map((c) => {
        return {
          ...c,
          name: `${c[this.formQNums.full_name]} - ${c[this.formQNums.drivers_license]} - ${c[this.formQNums.vehicle_make]}`,
        }
      });
    },
    user() {
      return this.$store.state.user || {ID: 0};
    },
    techDrops() {
      return this.$store.state.techs;
    },
    selectedTechIds() {
      return this.selectedTechs.map((i) => i.id);
    },
    currentTech() {
      let currentUserTech = {id: 0};
      if (this.user && this.techDrops.length > 0) {
        currentUserTech = this.techDrops.find(i => parseInt(this.user.ID) === i.user_id);
      }
      return currentUserTech;
    },
  },
  methods: {
    generate() {
      if (!this.selectedCustomer || this.selectedTemplates.length === 0 || !this.selectedCustomer.entry_id) {
        alert("Please select a customer and at least one template to generate forms.");
        return;
      }
      const shops = this.$store.state.shops;
      const shop = shops.find(i => i.id === parseInt(sessionStorage.getItem("sbShopId")));
      this.generateAllDocs(
          this.selectedCustomer.entry_id,
          this.selectedTemplates,
          this.currentTech,
          shop
      );
      if (this.takeRecord) {
        this.postTransaction(this.selectedCustomer, this.formQNums, this.selectedTechs);
      }
    },
    clear() {
      this.selectedCustomer = null;
      this.selectedTemplates = [];
    },
    setUserTech() {
      let currentUserTech = {id: 0};
      if (this.user && this.techDrops.length > 0) {
        currentUserTech = this.techDrops.find(i => parseInt(this.user.ID) === i.user_id);
      }
      if (!currentUserTech) {
        throw new Error("User is not registered as a technician.");
      }
      if (!this.selectedTechIds.includes(currentUserTech.id) && currentUserTech.id !== 0) {
        this.selectedTechs.push(currentUserTech);
      }
    },
    update() {
      this.getCustomers();
      this.selectedCustomer = null;
    }
  },
  created() {
    this.getCurrentUser();
    this.getFormData();
    this.getCustomers();
    this.getTemplates();
    this.getTechs();
    this.getShops();
  },
  watch: {
    user() {
      this.setUserTech();
    },
    techDrops() {
      this.setUserTech();
    },
    currentTech() {
      this.selectedTechs = [this.currentTech.id];
    }
  }
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <span class="text-6xl mt-4">Document Generator</span>
    <div class="flex gap-4">
      <div class="flex flex-col gap-4 w-1/2">
        <Panel header="Select a Customer">
          <Select :options="customers"
                  v-model="selectedCustomer"
                  optionLabel="name"
                  placeholder="Choose Customer"
                  class="w-full"
                  filter
                  :virtualScrollerOptions="{ itemSize: 38, delay: 300, showLoader: true }"
          />
        </Panel>
        <Panel header="Select a Template">
          <ul class="flex flex-col gap-1">
            <li v-for="t in templates" class="flex items-center gap-2">
              <Checkbox
                        :inputId="t.id"
                        :value="t.id"
                        v-model="selectedTemplates"
                        :aria-label="`${t.name} template selection`"/>
              <label :for="t.id">
                {{ t.name }}
              </label>
            </li>
          </ul>
        </Panel>
      </div>
      <div class="flex flex-col gap-4 w-1/2">
        <CustomerPreview :customer="selectedCustomer" :formQNums="formQNums" @update="update"></CustomerPreview>
        <Panel header="Select Associated Techs">
          <MultiSelect
              v-model="selectedTechs"
              :options="techDrops ?? []"
              optionLabel="name"
              optionValue="id"
              :maxSelectedLabels="3"
              display="chip"
              placeholder="Choose Techs"
              :filter="true"
              class="w-full"
          />
        </Panel>
        <div>
          <div>
            <div>
              <b>In order to save the transaction for the day, please check the following box.</b>
            </div>
            <div class="flex items-center gap-2">
              <Checkbox class="me-2"
                        v-model="takeRecord"
                        :binary="true"
                        inputId="recordTransaction"
                        aria-label="Record Transaction"/>
              <label for="recordTransaction">
                Record Transaction
              </label>
            </div>
          </div>
        </div>
        <div class="flex gap-4">
          <Button @click="generate"
                  icon="pi pi-file-pdf"
                  severity="primary"
                  label="Generate"/>
          <Button @click="clear"
                  icon="pi pi-eraser"
                  severity="secondary"
                  label="Clear"/>
        </div>
      </div>
    </div>
  </div>
</template>